import { Box, Container, Typography } from '@mui/material'

import { APP_CONFIG } from './constants'
import { EmailLinkForm } from './EmailLinkForm.tsx'
import { StyledPaper } from './style.ts'

export const LoginPage: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f0f2f5',
      }}
    >
      <Container maxWidth="sm">
        <Box sx={{ textAlign: 'center', marginBottom: 4 }}>
          <Typography
            variant="h3"
            component="h1"
            sx={{ color: '#1890ff', fontWeight: 'bold', marginBottom: 1 }}
          >
            {APP_CONFIG.icon} {APP_CONFIG.name}
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            {APP_CONFIG.description}
          </Typography>
        </Box>

        <StyledPaper>
          <Typography variant="h5" component="h2" sx={{ marginBottom: 3 }}>
            Sign in to your account
          </Typography>
          {/* Email Link Authentication */}
          <EmailLinkForm />
        </StyledPaper>
      </Container>
    </Box>
  )
}
